import React from 'react'
import adminfooterStyle from './AdminFooter.module.css'

export default function AdminFooter() {
  return (
    <>
    <footer className={adminfooterStyle.adminFooter}> </footer>
    </>
  )
}
